
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"fill":"currentColor","d":"M18.8 12.7437L18.1688 8H20.5c.825 0 1.5-.675 1.5-1.5v-5c0-.825-.675-1.5-1.5-1.5h-17C2.675 0 2 .675 2 1.5v5C2 7.325 2.675 8 3.5 8h2.33125L5.2 12.7437C2.18125 14.4688 0 17.4 0 20.95c0 .55.45 1 1 1h10v7.55c0 .0438.0062.0812.0125.1187l.5 2c.125.5001.8437.5063.9687 0l.5-2c.0125-.0375.0125-.0812.0125-.1187v-7.55h10c.55 0 1-.45 1-1C24 17.4 21.8187 14.4688 18.8 12.7437zM2.08125 19.95c.425-2.6812 2.475-4.775 4.96875-5.9063L8 6H4V2h16v4h-4l.9562 8.05c2.5 1.1375 4.5438 3.2375 4.9688 5.9062H2.08125V19.95z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M2.08125 19.95c.425-2.6812 2.475-4.775 4.96875-5.9063L8 6H4V2h16v4h-4l.9562 8.05c2.5 1.1375 4.5438 3.2375 4.9688 5.9062H2.08125V19.95z"}})])
          )
        }
      }
    